module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"charactersLimit":"Максимальное количество символов","enterTheCorrectAnswer":"Введите правильный ответ*","requiredField":"Обязательное поле для заполнения","enterANumValue":"Введите числовое значение"}}')
  delete Component.options._Ctor
}
